import { ManageScheduledEvents } from "@common-components/scheduled-contact-list/manage-scheduled-events";
import { Stack } from "@mui/system";
import ConditionalWrapper from "@common-components/conditional-wrapper/ConditionalWrapper";
import WhatsappContactList from "./whatsapp-contact-list";


const ContactList = () => {
  return (
    <Stack
      sx={{
        width: "500px",
        borderRight: "1px solid #d3d3d3",
        padding: "10px"
      }}
    >
      <ConditionalWrapper shouldLoadSelector={(state) => state.MainReducer.scheduledContactListOpen}>
        <ManageScheduledEvents />
      </ConditionalWrapper>
      <WhatsappContactList />
    </Stack>
  );
};

export default ContactList;